import styled from 'styled-components';

export const ContainerDados = styled.div`
  background-color: #fff;
  padding: 0.75rem;
  border: 1px solid #d7d7d7;
`;
